/**
 * Dashboard Service
 * Handles dashboard data and KPI operations
 */

import api from './api';

class DashboardService {
  /**
   * Get client dashboard KPIs
   * @returns {Promise<Object>} Dashboard KPIs
   */
  async getClientKPIs() {
    const response = await api.get('/dashboard/client/kpis');

    if (response.success && response.data) {
      return response.data.kpis;
    }

    throw new Error('Failed to fetch dashboard KPIs');
  }

  /**
   * Get client overview chart data
   * @returns {Promise<Array>} Chart data
   */
  async getClientOverview() {
    const response = await api.get('/dashboard/client/overview');

    if (response.success && response.data) {
      return response.data.chartData;
    }

    throw new Error('Failed to fetch overview data');
  }

  /**
   * Get recent tasks for client
   * @param {number} limit - Number of tasks to fetch
   * @returns {Promise<Array>} Recent tasks
   */
  async getRecentTasks(limit = 10) {
    const response = await api.get(`/dashboard/client/recent-tasks?limit=${limit}`);

    if (response.success && response.data) {
      return response.data.jobs;
    }

    throw new Error('Failed to fetch recent tasks');
  }
}

const dashboardService = new DashboardService();
export default dashboardService;
